<template>
  <div
    class="badge p-1"
    :class="[`badge-${RESEARCH_STATUS_CLASSES[status]}`, fullWidth ? 'w-100' : '']"
  >
    <i
      v-if="showIcon"
      class="fa mr-1"
      :class="iconClass"
    ></i>
    {{ t(`word.${status}`) }}
  </div>
</template>

<script>
import { RESEARCH_STATUS_CLASSES, RESEARCH_ICON_CLASSES } from '@/common/utils/constants';
import VueI18n from '@/i18n';

const t = (key) => VueI18n.t(key);

export default {
  name: 'ResearchStatusBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      RESEARCH_STATUS_CLASSES,
      RESEARCH_ICON_CLASSES,
    };
  },
  computed: {
    iconClass() {
      return [
        `fa-${this.RESEARCH_ICON_CLASSES[this.status]}`,
        this.status === 'in_progress' ? 'fa-spin' : '',
      ];
    },
  },
  methods: {
    t,
  },
};
</script>

<style scoped>
i.fa-spin {
  -webkit-animation:spin 4s linear infinite;
  -moz-animation:spin 4s linear infinite;
  animation:spin 4s linear infinite;
}

@-moz-keyframes spin {
  100% { -moz-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
  100% { -webkit-transform: rotate(360deg); }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform:rotate(360deg);
  }
}
</style>
